import React, { useState } from 'react';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import Switch from 'components/atoms/Switch/Switch';
import clsx from 'clsx';
import classes from './FilterSwitchCard.module.scss';

export interface FilterSwitchCardProps {
  title: string;
  description: string;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
  onHandleToggle?: () => void;
  isActive?: boolean;
}

const FilterSwitchCard: React.FC<FilterSwitchCardProps> = ({
  title,
  description,
  icon: Icon,
  className,
  onHandleToggle,
  isActive = false,
}) => {
  const [isChecked, setIsChecked] = useState(isActive);

  const handleToggle = () => {
    onHandleToggle?.();
  };

  return (
    <Card className={clsx(classes.root, className)}>
      {Icon && (
        <span className={classes.icon}>
          <Icon className={clsx(classes.iconSvg, !isActive && classes.inactive)} />
        </span>
      )}
      <Txt className={classes.title}>{title}</Txt>
      <span className={classes.description}>{description}</span>
      <div className={classes.toggleWrapper}>
        <Txt className={classes.toggleLabel}>off</Txt>
        <Switch
          checked={isChecked}
          onToggle={() => {
            setIsChecked(!isChecked);
            handleToggle();
          }}
          className={classes.switch}
        />
        <Txt className={classes.toggleLabel}>on</Txt>
      </div>
    </Card>
  );
};

export default FilterSwitchCard;
